import { RedoSideNavigation } from "@redotech/redo-web/arbiter-components/navigation/redo-side-navigation";
import { filterTruthy } from "@redotech/util/array";
import { memo, useMemo } from "react";
import { useAeoNavigation } from "./aeo/aeo-navigation";
import { useAnalyticsNavigation } from "./analytics/analytics-navigation";
import { useCatalogNavigation } from "./catalog/catalog-navigation";
import { useConversionNavigation } from "./conversion/conversion-navigation";
import { useCustomersNavigation } from "./customers/customers-navigation";
import { useDeveloperNavigation } from "./developer/developer-navigation";
import { useHomeNavigation } from "./home/home-navigation";
import { useInventoryNavigation } from "./inventory/inventory-navigation";
import { useMarketingNavigation } from "./marketing/marketing-navigation";
import { useOrdersPrimaryNavigation } from "./orders/orders-primary-navigation";
import { usePaymentsNavigation } from "./payments/payments-navigation";
import { useRedoSuppliesNavigation } from "./redo-supplies/redo-supplies-navigation";
import { useReturnsNavigation } from "./returns/returns-navigation";
import { useSettingsItems } from "./settings";
import { useShippingNavigation } from "./shipping/shipping-navigation";
import { useShopperAgentNavigation } from "./shopper-agent/shopper-agent-navigation";
import { useSupportNavigation } from "./support/support-navigation";

export const MerchantAppSideNav = memo(function MerchantAppSideNav({
  enterSettingsUrl,
  exitSettingsUrl,
  settingsRoot,
  hideNav,
  hideTeamSwitcher = false,
}: {
  enterSettingsUrl: string;
  exitSettingsUrl: string;
  settingsRoot: string;
  hideNav: boolean;
  hideTeamSwitcher?: boolean;
}) {
  const aeoEntry = useAeoNavigation();
  const analyticsEntry = useAnalyticsNavigation();
  const catalog = useCatalogNavigation();
  const conversionEntry = useConversionNavigation();
  const customers = useCustomersNavigation();
  const developer = useDeveloperNavigation();
  const homeEntry = useHomeNavigation();
  const inventory = useInventoryNavigation();
  const marketing = useMarketingNavigation();
  const orders = useOrdersPrimaryNavigation();
  const payments = usePaymentsNavigation();
  const returns = useReturnsNavigation();
  const shipping = useShippingNavigation();
  const shopperAgent = useShopperAgentNavigation();
  const supplies = useRedoSuppliesNavigation();
  const support = useSupportNavigation();

  const allPageEntries = useMemo(() => {
    // Entry order only affects selectedPrimaryTab find(); `orders` must precede
    // `shipping` because the Orders pathRoot is its strict prefix.
    return filterTruthy([
      homeEntry,
      customers,
      orders,
      analyticsEntry,
      developer,
      aeoEntry,
      catalog,
      conversionEntry,
      inventory,
      marketing,
      payments,
      supplies,
      returns,
      shipping,
      shopperAgent,
      support,
    ]);
  }, [
    aeoEntry,
    analyticsEntry,
    catalog,
    conversionEntry,
    customers,
    developer,
    homeEntry,
    inventory,
    marketing,
    orders,
    payments,
    returns,
    shipping,
    shopperAgent,
    supplies,
    support,
  ]);

  const settingsItems = useSettingsItems();

  return (
    <RedoSideNavigation
      enterSettingsUrl={enterSettingsUrl}
      exitSettingsUrl={exitSettingsUrl}
      hideTeamSwitcher={hideTeamSwitcher}
      isHidden={hideNav}
      pageEntries={allPageEntries}
      settingSections={settingsItems}
      settingsNavVariant="redesigned"
      settingsRoot={settingsRoot}
    />
  );
});
